import type { ClassifyPage } from "../api/client";

/**
 * Pure presentational helpers for the classify detail panel.
 * Extracted from ClassifyDetailPanel.tsx (R-260 CS-station cleanup).
 */

// ── Disabled "coming" button label by park reason ─────────────────────────────
// Only reached for park reasons whose resolution is genuinely unbuilt
// (split_orphan, unknown). `misordered` is now resolved live by the filmstrip
// reorder (shipped 5d-3), so the panel suppresses its "coming" button entirely.
export function comingLabel(parkReason: string): string {
  switch (parkReason) {
    case "split_orphan":
      return "Reassign pages (coming)";
    default:
      return "Resolution coming";
  }
}

// ── Page identity line ────────────────────────────────────────────────────────
export function pageIdentityLine(page: ClassifyPage): string {
  const parts: string[] = [];
  if (page.pageTypeName) parts.push(page.pageTypeName);
  if (page.pageLabel) parts.push(page.pageLabel);
  // F-057 — when no type/label resolved, say "Unidentified" explicitly. The
  // confidence describes the page-class SIGNAL, not a resolved identity, so a
  // bare "· 99%" used to look identical to an unscored page; operators couldn't
  // tell a high-confidence page had still failed to identify.
  if (parts.length === 0) parts.push("Unidentified");
  if (page.pageClassSource) parts.push(page.pageClassSource);
  if (page.pageClassConfidence !== null) {
    parts.push(`${Math.round(page.pageClassConfidence * 100)}%`);
  }
  return parts.join(" · ");
}
